
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38 19c0 10.493-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0s19 8.507 19 19z","fill":"#0FB400"}}),_c('path',{attrs:{"d":"M22.304 10c-2.114 0-3.805 1.669-3.805 3.755v3.754h-6.443c-.634 0-1.056.522-1.056 1.043v7.405c0 .626.528 1.043 1.056 1.043h9.719c.633 0 1.057-.521 1.057-1.043v-7.405c0-.626-.528-1.043-1.056-1.043h-1.058v-3.754c0-.835.74-1.565 1.584-1.565.845 0 1.585.73 1.585 1.565v2.607c0 .626.528 1.043 1.056 1.043S26 16.883 26 16.362v-2.607C26 11.669 24.31 10 22.303 10zm-4.86 13.141v1.147c0 .313-.212.522-.529.522-.316 0-.529-.209-.529-.522v-1.147a1.57 1.57 0 01-1.055-1.46c0-.834.739-1.564 1.583-1.564.845 0 1.585.73 1.585 1.564 0 .73-.422 1.252-1.056 1.46z","fill":"#fff"}})])
          )
        }
      }
    